import React, { useState } from 'react';
import './TipSelector.css';

const TipSelector = ({ onTipChange }) => {
  const [selectedTip, setSelectedTip] = useState(0.15);
  const tipOptions = [0, 0.10, 0.15, 0.20, 0.30];

  const handleTipSelect = (tip) => {
    setSelectedTip(tip);
    if (onTipChange) {
      onTipChange(tip);
    }
  };

  return (
    <div className="tip-selector">
      <h4>Tip</h4>
      <div className="tip-options">
        {tipOptions.map(tip => (
          <button
            key={tip}
            className={`tip-option ${selectedTip === tip ? 'active' : ''}`}
            onClick={() => handleTipSelect(tip)}
          >
            {tip === 0 ? '0%' : `${tip * 100}%`}
          </button>
        ))}
      </div>
    </div>
  );
};

export default TipSelector;